<template>
    <div class="w-full h-full relative">
        <div class="fixed p-2 z-[5] w-3xs md:w-[400px]" ref="searchbox" :class="iframe ? 'md:!w-[300px]' : ''">
            <div class="relative mx-auto text-gray-600 relative w-full">
                <input v-model="filters.search"
                    class="border-2 w-full border-gray-300 bg-white h-12 px-5 pr-16 rounded-full text-sm focus:outline-none"
                    type="search" name="search" placeholder="Search">
                <button type="submit" class="absolute right-0 top-0 mt-1 mr-2 p-3 hover:bg-gray-100 rounded-full">
                    <svg class="text-gray-600 h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                        viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 56.966 56.966;" xml:space="preserve"
                        width="512px" height="512px">
                        <path
                            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                    </svg>
                </button>
            </div>
        </div>
        <div class="h-screen w-screen !fixed" ref="mapContainer"></div>

        <div v-show="selectedLocation" ref="sidewindow" :key="forceUpdate"
            class="flex flex-col gap-2 left-0 top-[90%] md:bottom-none md:top-0 md:z-1"
            :class="iframe ? 'md:!w-[300px]' : ''">

            <div
                class="h-[90vh] -mb-6 z-1 md:hidden pointer-events-none bg-gradient-to-t from-neutral-900/20 from-0% to-transparent to-10%">
            </div>
            <div
                class="sticky -mb-6 md:hidden top-2 z-[7] bg-neutral-100/50 dark:bg-neutral-800/50 backdrop-blur-xl border border-gray-100/30 dark:border-neutral-800/10 left-[50%] rounded-full w-[50%] h-2 -translate-x-[50%]">
            </div>
            <div
                class="w-full min-h-[95vh] z-[6] md:z-[4] md:min-h-auto md:h-full rounded-t-3xl md:rounded-none bg-neutral-100/50 dark:bg-neutral-800/50 dark:text-white backdrop-blur-xl shadow-2xl md:shadow-lg  md:w-[400px] border border-neutral-800/10">
                <div class="relative">
                    <img v-if="selectedLocationData?.image_link" :src="selectedLocationData.image_link"
                        class="w-full h-48 md:h-64  bg-gray-400 object-cover rounded-t-2xl md:rounded-none"
                        :class="iframe ? 'md:!h-36' : ''">
                    <div v-else class="w-full h-48 md:h-64 bg-gray-400 rounded-t-2xl md:rounded-none">
                    </div>
                    <template v-if="selectedLocationData?.logo_link">
                        <img :src="selectedLocationData.logo_link"
                            class="bg-white absolute bottom-0 right-4 translate-y-[50%] w-28 h-28 object-contain rounded-full border-2 border-white shadow-xl"
                            :class="iframe ? '!w-16 !h-16' : ''">
                    </template>
                </div>
                <div class="flex py-4 flex-col" :class="iframe ? '!pt-2' : ''">
                    <div class="px-4 py-1 flex flex-col max-w-[70%]">
                        <span class="text-2xl font-bold" :class="iframe ? '!text-xl' : ''"> {{
                            getTranslated(selectedLocationData?.name) }} </span>
                        <span class="text-xs text-gray-500">
                            {{ selectedLocationData?.street }}, {{ selectedLocationData?.postcode }} {{
                                selectedLocationData?.city
                            }}
                        </span>
                        <div :class="`shrink-0 flex gap-2 items-center my-2`">
                            <div :class="`${meta(selectedLocationData?.type).color}`">
                                <svg-vue class="h-4" :icon="meta(selectedLocationData?.type).icon" />
                            </div>
                            <div :class="`${meta(selectedLocationData?.type).color} text-xs`">
                                {{ meta(selectedLocationData?.type).label }}
                            </div>
                        </div>
                    </div>
                    <div class="px-4 select-none flex gap-2 mb-2 w-full overflow-x-scroll py-1 scrollbar-hide">
                        <a v-for="category in selectedLocationData?.platform_categories" :key="category.slug"
                            :href="$baseUrl + `/categories/${category.slug}`" :class="[
                                `category_${category.slug}`,
                                'py-2 px-3 bg-neutral-100/50 nowrap dark:bg-neutral-700/50 backdrop-blur-xl rounded-full border border-neutral-300 dark:!border-gray-500 dark:text-white text-xs capitalize flex gap-1 items-center justify-between hover:scale-110 active:scale-90 transition'
                            ]">
                            <div v-if="category.iconSvg" class="w-4 h-4" v-html="category.iconSvg"></div>
                            <span v-if="category.iconUrl" class="w-0 h-0 overflow-hidden">{{ category.iconUrl }}</span>
                            <span class="whitespace-nowrap">{{ getTranslated(category.name) }}</span>
                        </a>
                    </div>
                    <a :href="$baseUrl + '/locations/' + selectedLocationData?.slug" target="_blank"
                        class="mx-4 block my-1 bg-gradient shadow-xl px-5 py-3 md:py-5 mb-2 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center"
                        :class="iframe ? '!py-3' : ''">
                        <span>
                            {{ $t('See location') }}
                        </span>
                    </a>
                    <span class="px-4 text-base dark:text-white"
                        v-html="getTranslated(selectedLocationData?.meta_description)"></span>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { useTypeMeta } from '../helpers/useTypeMeta'
const { debounce } = require('lodash');

export default {
    name: 'Map',

    props: {
        iframe: {
            type: Boolean,
            default: false,
        },
        locations: {
            type: Array,
            default: [],
        }
    },

    data() {
        return {
            allLocations: [],
            promotions: [],
            map: null,
            selectedLocation: null,
            forceUpdate: 0,
            filters: {
                search: '',
                date: '',
                location_id: '',
            },
            isDarkMode: false,
        };
    },

    mounted() {
        this.detectDarkMode();

        // Optional: listen for changes in the user's system preference
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.detectDarkMode);

        const initialState = {
            lng: 6.564133087784059,
            lat: 53.2187079160419,
            zoom: 14
        };

        if (this.isDarkMode) {
            var mapUrl = 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';
        } else {
            var mapUrl = 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';
        }

        this.map = new maplibregl.Map({
            container: this.$refs.mapContainer,
            style: mapUrl,
            center: [initialState.lng, initialState.lat],
            zoom: initialState.zoom
        });


        this.map.on('load', async () => {

            this.map.addControl(new maplibregl.NavigationControl(), 'top-right');

            // Initial empty source
            const initialGeoJSON = {
                type: 'FeatureCollection',
                features: [],
            };

            this.map.addSource('locations', {
                type: 'geojson',
                data: initialGeoJSON,
            });

            const initialGeoJSONPromotions = {
                type: 'FeatureCollection',
                features: [],
            };

            this.map.addSource('promotions', {
                type: 'geojson',
                data: initialGeoJSONPromotions,
            });

            // await this.drawRouteWithOSRM();

            // ...new Set(this.locations.map(loc => loc.icon).filter(Boolean))
            // Get unique icon names from locations
            const iconNames = [
                "must_see",
                "shopping",
                "amusement",
                "food_and_drinks",
                "parking",
                "services",
                "park",
                "health",
                "institution",
                "activity",
                "transportation",
                "must_see_small",
                "shopping_small",
                "amusement_small",
                "food_and_drinks_small",
                "parking_small",
                "services_small",
                "park_small",
                "health_small",
                "institution_small",
                "activity_small",
                "transportation_small",

                "promotion",
                "default",
                "iconDot",
            ];

            await Promise.all(iconNames.map(async name => {
                try {
                    const highResImg = await this.loadSVGAsHighResImage(this.$baseUrl + `/platform/images/icons/map/${name}.svg`);
                    if (!this.map.hasImage(name)) {
                        this.map.addImage(name, highResImg);
                    }
                } catch (error) {
                    console.warn(`Error loading image for icon ${name}`, error);
                }
            }));

            const textColor = this.isDarkMode ? '#c2c2c2' : '#000';
            const textHaloColor = this.isDarkMode ? '#202020' : '#fff';


            this.map.addLayer({
                id: 'locations',
                type: 'symbol',
                source: 'locations',
                layout: {
                    'icon-size': 0.3,
                    'icon-padding': 20,
                    'icon-allow-overlap': false,
                    'icon-image': ['coalesce', ['get', 'type'], 'default'],
                    'text-field': ['get', 'title'],
                    'text-size': 14,
                    'text-variable-anchor': ['left', 'right'],
                    'text-radial-offset': 1.5,
                    'text-justify': 'auto',
                    'text-optional': true,
                    'text-allow-overlap': false,
                },
                paint: {
                    'text-color': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false],
                        '#007aff', // Hover color (e.g. blue)
                        textColor    // Default color
                    ],
                    'text-halo-color': textHaloColor,
                    'text-halo-width': 1.5
                }
            });


            const circleColor = getComputedStyle(document.documentElement).getPropertyValue('--main_color').trim();
            const opcColor = getComputedStyle(document.documentElement).getPropertyValue('--main_color_opc').trim();

            this.map.addLayer({
                id: 'promotions',
                type: 'symbol',
                source: 'promotions',
                layout: {
                    'icon-size': 0.5,
                    'icon-allow-overlap': true,
                    'icon-image': ['coalesce', ['get', 'icon_id'], 'promotion'],
                    'text-field': ['get', 'title'],
                    'text-size': 15,
                    'text-variable-anchor': ['left', 'right'],
                    'text-radial-offset': 1.55,
                    'text-justify': 'auto',
                    'text-optional': true,
                    'text-allow-overlap': false,
                    'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold']
                },
                paint: {
                    'text-color': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false],
                        '#007aff', // Hover color
                        textColor     // Default color
                    ],
                    'text-halo-color': textHaloColor,
                    'text-halo-width': 1.5
                },
                filter: ['all']
            });

            this.map.addLayer({
                id: 'locations-selected',
                type: 'symbol',
                source: 'locations',
                layout: {
                    'icon-size': 0.4,
                    'icon-image': ['coalesce', ['get', 'type'], 'default'],
                    'icon-anchor': 'bottom',
                    'icon-allow-overlap': true,
                    'text-field': ['get', 'title'],
                    'text-size': 16,
                    'text-anchor': 'left',
                    'text-justify': 'left',
                    'text-offset': [2, -2.1],
                    'text-optional': true,
                    'text-allow-overlap': false,
                },
                paint: {
                    'text-color': textColor,
                    'text-halo-color': textHaloColor,
                    'text-halo-width': 1.5
                },
                filter: ['==', 'id', ''] // no selection initially
            });

            this.map.addLayer({
                id: 'locations-selected-circle',
                type: 'circle',
                source: 'locations',
                paint: {
                    'circle-radius': 30,
                    'circle-color': opcColor,
                    'circle-stroke-color': circleColor,
                    'circle-stroke-width': 2,
                    // Optionally add animation by toggling circle-opacity or radius with setInterval
                },
                filter: ['==', 'id', ''] // no selection at start
            }, 'locations-selected');

            this.map.addLayer({
                id: 'dots',
                type: 'symbol',
                source: 'locations',
                layout: {
                    'icon-size': 0.4,
                    'icon-allow-overlap': false,
                    'icon-image': [
                        'coalesce',
                        ['concat', ['get', 'type'], '_small'],
                        'default_small'
                    ]
                },
            }, 'locations');

            // Start loading location data
            await this.loadLocationsToMap();

            this.map.addControl(
                new maplibregl.GeolocateControl({
                    positionOptions: {
                        enableHighAccuracy: true
                    },
                    trackUserLocation: true
                })
            );

            let hoveredLocationId = null;


            this.map.on('mousemove', 'locations', (e) => {
                if (e.features.length > 0) {
                    const featureId = e.features[0].id;

                    // Remove hover state from previous
                    if (hoveredLocationId !== null && hoveredLocationId !== featureId) {
                        this.map.setFeatureState({ source: 'locations', id: hoveredLocationId }, { hover: false });
                    }

                    // Set new hover state
                    hoveredLocationId = featureId;
                    this.map.setFeatureState({ source: 'locations', id: hoveredLocationId }, { hover: true });
                }
            });

            this.map.on('mouseleave', 'locations', () => {
                if (hoveredLocationId !== null) {
                    this.map.setFeatureState({ source: 'locations', id: hoveredLocationId }, { hover: false });
                }
                hoveredLocationId = null;
            });

            let hoveredPromotionId = null;

            this.map.on('mousemove', 'promotions', (e) => {
                if (e.features.length > 0) {
                    const featureId = e.features[0].id;


                    if (hoveredPromotionId !== null && hoveredPromotionId !== featureId) {
                        this.map.setFeatureState({ source: 'promotions', id: hoveredPromotionId }, { hover: false });
                    }

                    hoveredPromotionId = featureId;
                    this.map.setFeatureState({ source: 'promotions', id: hoveredPromotionId }, { hover: true });
                }
            });

            this.map.on('mouseleave', 'promotions', () => {
                if (hoveredPromotionId !== null) {
                    this.map.setFeatureState({ source: 'promotions', id: hoveredPromotionId }, { hover: false });
                }
                hoveredPromotionId = null;
            });

            this.map.on('click', 'locations', (e) => {
                this.handleFeatureClick(e.features[0]);
            });

            this.map.on('click', 'promotions', (e) => {
                this.handleFeatureClick(e.features[0], true);
            });

            this.map.on('click', (e) => {
                const features = this.map.queryRenderedFeatures(e.point, {
                    layers: ['locations', 'promotions']
                });

                if (!features.length) {
                    this.selectedLocation = null;

                    this.map.setFilter('locations-selected', ['==', 'id', '']);
                    this.map.setFilter('locations-selected-circle', ['==', 'id', '']);
                    this.map.setFilter('promotions', ['all']);

                    const url = new URL(window.location.href);
                    url.searchParams.delete('location');
                    window.history.replaceState({}, '', url);
                }
            });

            // Handle pre-selected location from URL
            const selectedId = new URLSearchParams(window.location.search).get('location');

            if (selectedId) {
                const selectedFeature = this.locations.find(loc => loc.id == selectedId);

                if (selectedFeature) {
                    this.selectedLocation = parseInt(selectedId);

                    this.$nextTick(() => {
                        const coordinates = [selectedFeature.long, selectedFeature.lat];

                        this.map.setFilter('promotions', ['!=', ['get', 'id'], parseInt(selectedId)]);
                        this.map.setFilter('locations-selected', ['==', 'id', parseInt(selectedId)]);
                        this.map.setFilter('locations-selected-circle', ['==', 'id', parseInt(selectedId)]);

                        this.centerMapOnCoordinates(coordinates);

                        if (window.innerWidth < 768) {
                            this.scrollToFocusArea();
                        }

                        this.forceUpdate++;
                    });
                }
            }

            let growing = true;
            let radius = 15;

            const intervalId = setInterval(() => {
                // Check if layer exists
                if (this.map.getLayer('locations-selected-circle')) {
                    radius = growing ? radius + 1 : radius - 1;
                    if (radius >= 20) growing = false;
                    if (radius <= 10) growing = true;

                    this.map.setPaintProperty('locations-selected-circle', 'circle-radius', radius);
                } else {
                    // Layer no longer exists, stop the animation
                    clearInterval(intervalId);
                }
            }, 100);
        });
    },
    computed: {
        selectedLocationData() {
            return this.locations.find(loc => loc.id == this.selectedLocation);
        }
    },
    methods: {
        detectDarkMode() {
            this.isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        },
        async drawRouteWithOSRM() {
            // Example route with 10 waypoints
            const points = [
                [13.388860, 52.517037],
                [13.397634, 52.529407],
                [13.428555, 52.523219],
                [13.438792, 52.519243],
                [13.450995, 52.512411],
                [13.452900, 52.506912],
                [13.440971, 52.502907],
                [13.421860, 52.500436],
                [13.400581, 52.503525],
                [13.388000, 52.509000],
            ];

            try {
                // Build OSRM query
                const coordsString = points.map(p => p.join(',')).join(';');
                const url = `https://router.project-osrm.org/route/v1/driving/${coordsString}?overview=full&geometries=geojson`;

                const res = await fetch(url);
                const data = await res.json();
                if (!data.routes || data.routes.length === 0) throw new Error('No route found');
                const route = data.routes[0].geometry;

                // Add source if not present
                if (!this.map.getSource('route')) {
                    this.map.addSource('route', {
                        type: 'geojson',
                        data: route
                    });

                    this.map.addLayer({
                        id: 'route-line',
                        type: 'line',
                        source: 'route',
                        layout: {
                            'line-join': 'round', // round joins at corners
                            'line-cap': 'round'   // round endpoints
                        },
                        paint: {
                            'line-color': '#007aff',
                            'line-width': 5
                        }
                    });
                } else {
                    this.map.getSource('route').setData(route);
                }

                // Add markers for clarity
                points.forEach((p, i) => {
                    new maplibregl.Marker({
                        color: i === 0 ? 'green' : (i === points.length - 1 ? 'red' : 'gray')
                    }).setLngLat(p).addTo(this.map);
                });

                // Fit map bounds to route
                const bounds = new maplibregl.LngLatBounds();
                route.coordinates.forEach(c => bounds.extend(c));
                this.map.fitBounds(bounds, { padding: 50 });
            } catch (err) {
                console.error('Error drawing route:', err);
            }
        },
        handleFeatureClick(feature, isPromotion = false) {
            const selectedId = feature.properties.id;
            const coordinates = feature.geometry.coordinates;

            this.selectedLocation = selectedId;

            this.map.setFilter('locations-selected', ['==', 'id', selectedId]);
            this.map.setFilter('locations-selected-circle', ['==', 'id', selectedId]);

            if (isPromotion) {
                this.map.setFilter('promotions', ['!=', ['get', 'id'], selectedId]);
            }

            this.$nextTick(() => {
                this.centerMapOnCoordinates(coordinates);

                const url = new URL(window.location.href);
                url.searchParams.set('location', selectedId);
                window.history.replaceState({}, '', url);

                if (window.innerWidth < 768) {
                    this.scrollToFocusArea();
                }
            });
        },

        centerMapOnCoordinates(coordinates) {
            const sidebarWidth = this.$refs.searchbox?.offsetWidth || 0;
            const point = this.map.project(coordinates);

            var rect = this.$refs.mapContainer.getBoundingClientRect();
            var viewportX = [rect.bottom];
            var shiftScreen = 0.5 * -0.3 * viewportX;
            var OffsetX = 0;
            var OffsetY = 0;

            if (window.innerWidth >= 768 && sidebarWidth > 0) {
                OffsetX = sidebarWidth / 2;
            } else if (window.innerWidth < 768) {
                OffsetY = window.innerHeight / 4;
            }

            const newCenter = this.map.unproject(point);

            this.map.easeTo({
                center: [newCenter.lng, newCenter.lat],
                zoom: 17,
                offset: [OffsetX, -OffsetY],
            });
        },

        scrollToFocusArea() {
            window.scrollTo({
                top: document.body.scrollHeight / 5,
                behavior: 'smooth'
            });
        },
        async loadSVGAsHighResImage(url, pixelRatio = Math.min(Math.max(window.devicePixelRatio || 1, 1), 3)) {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Failed to load SVG at ${url}`);
            const svgText = await response.text();

            // Parse dimensions from the SVG itself
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
            const svgEl = svgDoc.documentElement;

            let width = parseFloat(svgEl.getAttribute('width'));
            let height = parseFloat(svgEl.getAttribute('height'));

            if (!width || !height) {
                const viewBox = svgEl.getAttribute('viewBox');
                if (viewBox) {
                    const [, , vbWidth, vbHeight] = viewBox.split(/\s+/).map(parseFloat);
                    width = vbWidth;
                    height = vbHeight;
                }
            }

            // Fallback if dimensions are still invalid
            if (!width || !height) {
                width = 64;
                height = 64;
            }

            const img = new Image();
            const svgDataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgText);
            img.src = svgDataUrl;

            return new Promise((resolve, reject) => {
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = width * pixelRatio;
                    canvas.height = height * pixelRatio;

                    const ctx = canvas.getContext('2d');
                    ctx.scale(pixelRatio, pixelRatio);
                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob(blob => {
                        if (!blob) return reject('Failed to create blob');
                        const highResImg = new Image();
                        const url = URL.createObjectURL(blob);
                        highResImg.onload = () => {
                            URL.revokeObjectURL(url);
                            resolve(highResImg);
                        };
                        highResImg.onerror = reject;
                        highResImg.src = url;
                    });
                };
                img.onerror = reject;
            });
        },
        async loadLocationsToMap() {
            // If locations are already loaded, skip the API calls
            if (this.locations && this.locations.length > 0) {
                const allFeatures = this.locations.map(f => ({
                    type: 'Feature',
                    id: f.id,
                    geometry: {
                        type: 'Point',
                        coordinates: [f.long, f.lat],
                    },
                    properties: {
                        id: f.id,
                        title: f.name?.en || `Locatie ${f.id}`,
                        type: f.type,
                        color: f.color || 'red',
                    },
                }));

                this.updateMapFeatures(allFeatures);
                this.loadPromotions('location');
                return;
            }

            // Otherwise, fetch locations from API
            let page = 1;
            let hasMore = true;
            const allFeatures = [];
            const allData = [];

            while (hasMore) {
                const response = await fetch(`/resources/locations?page=${page}`);
                const result = await response.json();

                allData.push(...result.data);
                this.locations.push(...result.data);
                this.allLocations.push(...result.data);

                const newFeatures = result.data.map(f => ({
                    type: 'Feature',
                    id: f.id,
                    geometry: {
                        type: 'Point',
                        coordinates: [f.long, f.lat],
                    },
                    properties: {
                        id: f.id,
                        title: f.name?.en || `Locatie ${f.id}`,
                        type: f.type,
                        color: f.color || 'red',
                    },
                }));

                allFeatures.push(...newFeatures);
                this.updateMapFeatures(allFeatures);

                hasMore = result.current_page < result.last_page;
                page++;
            }

            this.allLocations = allData;
            this.locations = allData;

            this.updateMapFeatures(allFeatures);
            this.loadPromotions('location');
        },

        async loadPromotions(resourceType = null) {
            try {
                let url = '/resources/promotions';
                if (resourceType) {
                    url += `?type=${resourceType}`;
                }

                const response = await fetch(url,
                    {
                        credentials: 'same-origin',
                    });
                const result = await response.json();
                this.promotions = result.data;

                const features = [];

                for (const promotion of result.data) {
                    if (!promotion || !promotion.item_id) continue;

                    const location = this.allLocations.find(loc => loc.id == promotion.item_id);
                    if (!location) continue;

                    let imageId = 'promotion'; // fallback icon ID
                    let imageUrl = null;

                    if (promotion.image_link) {
                        imageId = `promotion-icon-${location.id}`;
                        imageUrl = `/resources/promotion-icon?image_url=${encodeURIComponent(promotion.image_link)}`;

                        // Load image only if it hasn't already been added
                        if (!this.map.hasImage(imageId)) {
                            try {
                                const highResImg = await this.loadSVGAsHighResImage(imageUrl);
                                this.map.addImage(imageId, highResImg);
                            } catch (err) {
                                console.warn(`Failed to load SVG image for promotion ${location.id}`, err);
                            }
                        }
                    }

                    features.push({
                        type: 'Feature',
                        id: location.id,
                        geometry: {
                            type: 'Point',
                            coordinates: [location.long, location.lat],
                        },
                        properties: {
                            id: location.id,
                            title: location.name?.en || `Locatie ${location.id}`,
                            icon_id: imageId,
                            type: location?.type,
                            promotionOrder: promotion.order,
                            promotionCosts: promotion.promotion_costs,
                        },
                    });
                }

                const source = this.map.getSource('promotions');
                if (source) {
                    source.setData({
                        type: 'FeatureCollection',
                        features,
                    });
                }

            } catch (error) {
                console.error('Error loading promotions:', error);
            }
        },

        searchLocations: _.debounce(function () {
            const hasFilters = Object.values(this.filters).some(val => val);

            let features = [];

            if (!hasFilters) {
                this.map.setFilter('promotions', ['all']);
                this.locations = [...this.allLocations];
                features = this.allLocations.map(f => ({
                    type: 'Feature',
                    id: f.id,
                    geometry: {
                        type: 'Point',
                        coordinates: [f.long, f.lat],
                    },
                    properties: {
                        id: f.id,
                        title: f.name?.en || `Locatie ${f.id}`,
                        type: f.type,
                        color: f.color || 'red',
                    },
                }));
            } else {
                this.map.setFilter('promotions', ['==', 'id', '']);
                const query = new URLSearchParams(this.filters).toString();
                fetch(`/resources/locations?${query}`,
                    {
                        credentials: 'same-origin',
                    })
                    .then(res => res.json())
                    .then(json => {
                        this.locations = json.data;
                        features = json.data.map(f => ({
                            type: 'Feature',
                            id: f.id,
                            geometry: {
                                type: 'Point',
                                coordinates: [f.long, f.lat],
                            },
                            properties: {
                                id: f.id,
                                title: f.name?.en || `Locatie ${f.id}`,
                                type: f.type,
                                color: f.color || 'red',
                            },
                        }));

                        const source = this.map.getSource('locations');
                        if (source) {
                            source.setData({
                                type: 'FeatureCollection',
                                features,
                            });
                        }
                    });
                return; // exit early because fetch is async
            }

            // For no filters, update source synchronously
            const source = this.map.getSource('locations');
            if (source) {
                source.setData({
                    type: 'FeatureCollection',
                    features,
                });
            }
        }, 300),

        updateMapFeatures(features) {
            const source = this.map.getSource('locations');
            if (source) {
                source.setData({
                    type: 'FeatureCollection',
                    features,
                });
            }
        },
        meta(type) {
            return useTypeMeta(type)
        },
        getTranslated(item, lang = 'en') {
            if (!item) return '';

            const translations = item[lang] || item['en'];
            return translations;
        }
    },
    watch: {
        'filters': {
            handler: _.debounce(function (val) {
                this.searchLocations();
            }, 300),
            immediate: false,
            deep: true,
        },
    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove();
        }
        window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', this.detectDarkMode);

    }
};
</script>